
import React, { useState } from 'react';
import { WAITLIST_SCRIPT_URL } from '../constants';

const WaitlistSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleWaitlistSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      // Send data to Google Sheets script using 'no-cors' mode
      await fetch(WAITLIST_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'Footer Section' }),
      });
      
      setSubmitted(true);
      setEmail('');
    } catch (error) {
      console.error('Waitlist submission failed:', error);
      // Fallback success for user experience consistency
      setSubmitted(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="waitlist-section" className="max-w-[1400px] mx-auto border-x border-border border-b bg-primary py-24 px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <span className="inline-block py-1 px-3 rounded-full bg-white/10 text-[10px] font-mono text-white mb-6 uppercase tracking-widest border border-white/20">Early Access</span>
        <h2 className="text-4xl md:text-6xl font-display tracking-tight text-white uppercase leading-none mb-8">We’re Building This — <span className="text-neutral-500">With You.</span></h2>
        <p className="text-neutral-400 text-lg mb-12">
          Zetra is currently in early access. We’re onboarding printers city by city and improving the platform every week.
        </p>

        {!submitted ? (
          <form onSubmit={handleWaitlistSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input 
              type="email" 
              required
              placeholder="Your email address" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-grow h-14 px-6 rounded-full bg-white/5 border border-white/20 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 placeholder:text-neutral-500 backdrop-blur-sm"
            />
            <button 
              type="submit"
              disabled={isLoading}
              className="bg-white text-black px-8 h-14 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-neutral-200 transition-all shadow-2xl whitespace-nowrap flex items-center justify-center min-w-[160px]"
            >
              {isLoading ? (
                <iconify-icon icon="lucide:loader-2" class="animate-spin text-lg"></iconify-icon>
              ) : (
                'Join the Waitlist'
              )}
            </button>
          </form>
        ) : (
          <div className="bg-white/10 border border-white/20 p-8 rounded-3xl backdrop-blur-md animate-in fade-in zoom-in duration-500 max-w-md mx-auto">
             <iconify-icon icon="lucide:check-circle" class="text-4xl text-green-400 mb-4"></iconify-icon>
             <h3 className="text-xl font-bold text-white mb-2">You're in!</h3>
             <p className="text-neutral-400 text-sm">We've added your details to the waitlist. We'll be in touch with you to keep you updated.</p>
          </div>
        )}
        
        <p className="text-[10px] font-mono text-neutral-500 mt-6 uppercase tracking-widest">Be the first to print when we launch in your area</p>
      </div>
    </section>
  );
};

export default WaitlistSection;
